export const TOGGLE_SAVE_CARD = "TOGGLE_SAVE_CARD";
export const PURCHASE_PREPAID_BALANCE_START = "PURCHASE_PREPAID_BALANCE_START";
export const PURCHASE_PREPAID_BALANCE_SUCCESS =
    "PURCHASE_PREPAID_BALANCE_SUCCESS";
export const PURCHASE_PREPAID_BALANCE_FAILURE =
    "PURCHASE_PREPAID_BALANCE_FAILURE";
export const RESET_FORM = "RESET_FORM";
export const HANDLE_QUANTITY_INPUT_CHANGE = "HANDLE_QUANTITY_INPUT_CHANGE";
export const SET_QUANTITY_TO_ADD_INPUT_ERROR =
    "SET_QUANTITY_TO_ADD_INPUT_ERROR";
export const CLEAR_QUANTITY_TO_ADD_INPUT_ERROR =
    "CLEAR_QUANTITY_TO_ADD_INPUT_ERROR";
export const SET_UPDATING_CARD = "SET_UPDATING_CARD";
export const SET_SAVED_CREDIT_CARD = "SET_SAVED_CREDIT_CARD";
export const UPDATE_STRIPE_FORM_DATA = "UPDATE_STRIPE_FORM_DATA";
export const SET_CURRENT_PREPAID_BALANCE = "SET_CURRENT_PREPAID_BALANCE";
export const RESET_TO_DEFAULT = "RESET_TO_DEFAULT";
